import React from 'react';
import { FiX } from 'react-icons/fi';

const Modal = ({ isOpen, onClose, title, children, footer, size = 'lg' }) => {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-xl',
    lg: 'max-w-3xl',
    xxl: 'max-w-4xl',
    xl: 'max-w-5xl',
    '2xl': 'max-w-7xl',
  };

  return (
    <div className="fixed inset-0 z-50">
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/50 backdrop-blur-sm transition-opacity"
        onClick={onClose}
      ></div>

      {/* Modal Container */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div 
          className={`relative rounded-2xl shadow-2xl w-full ${sizeClasses[size]} max-h-[calc(100vh-2rem)] flex flex-col transform transition-all bg-white`}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className={`flex-shrink-0 flex items-center justify-between px-6 py-3 border-b border-slate-200`}>
            <h2 className={`text-lg font-semibold text-slate-800`}>{title}</h2>
            <button
              onClick={onClose}
              className={`w-8 h-8 flex items-center justify-center rounded-lg transition-colors hover:bg-slate-100 text-slate-400 hover:text-slate-600`}
            >
              <FiX className="text-xl" />
            </button>
          </div>

          {/* Body */}
          <div className={`flex-1 min-h-0 py-3 overflow-y-auto overflow-x-hidden scrollbar-hide`} style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
            <div className="px-6">
              {children}
            </div>
          </div>

          {/* Footer */}
          {footer && (
            <div className={`flex-shrink-0 flex items-center justify-end gap-3 px-6 py-3 border-t rounded-b-2xl border-slate-200 bg-slate-50`}>
              {footer}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
